import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-77620435")

_pushScopeId("data-v-77620435")
const _hoisted_1 = { class: "menu-list" }
const _hoisted_2 = { class: "conversation" }
const _hoisted_3 = { class: "image is-48x48" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "user_status" }, null, -1)
const _hoisted_5 = { class: "inbox_conversations_list" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "far fa-star is-yellow" }, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "badge"
}
const _hoisted_9 = {
  key: 1,
  class: "badge"
}
const _hoisted_10 = { class: "title is-4 is-white is-center no-margin" }
const _hoisted_11 = /*#__PURE__*/_createVNode("a", { class: "chevron_left is-white" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" })
], -1)
const _hoisted_12 = { class: "dropdown-trigger" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "fas fa-cog" }, null, -1)
const _hoisted_14 = {
  class: "dropdown-menu",
  id: "dropdown-menu2",
  role: "menu"
}
const _hoisted_15 = { class: "dropdown-content is-background-black has-border" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "dropdown-item" }, [
  /*#__PURE__*/_createVNode("strong", null, "Settings")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "dropdown-item is-clickable" }, " Unpin conversation ", -1)
const _hoisted_18 = {
  key: 0,
  class: "message_date"
}
const _hoisted_19 = { class: "inbox_picture" }
const _hoisted_20 = { class: "image is-48x48" }
const _hoisted_21 = { class: "inbox_message" }
const _hoisted_22 = { class: "message_infos" }
const _hoisted_23 = { "data-testid": "inbox-message-from" }
const _hoisted_24 = {
  "data-testid": "inbox-message-text",
  class: "message_text"
}
const _hoisted_25 = {
  key: 0,
  class: "field is-grouped padding-0-15"
}
const _hoisted_26 = { class: "control has-icons-right is-expanded" }
const _hoisted_27 = { class: "control" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane is-white" }, null, -1)
const _hoisted_29 = {
  key: 2,
  class: "is-relative is-center top-35"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "title is-2" }, "NO MESSAGES YET", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("p", null, "DON’T BE SHY...", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", null, "REGISTER TO A CTF AND START TALKING TO SOMEONE", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: "container is-fluid no-padding is-white",
    style: {
      position: _ctx.windowWidth < 768 && _ctx.activeDiscussion ? 'fixed' : ''
    }
  }, [
    _createVNode("div", {
      class: "inbox",
      style: { height: _ctx.windowHeight + 'px' }
    }, [
      ((!_ctx.activeDiscussion && _ctx.windowWidth < 768) || _ctx.windowWidth > 768)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: _ctx.windowWidth < 768 ? '' : 'conversations_container'
          }, [
            _createVNode("ul", _hoisted_1, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.conversations, (inboxUsername) => {
                return (_openBlock(), _createBlock("li", {
                  key: inboxUsername.username,
                  "data-testid": "inbox-user-list"
                }, [
                  _createVNode("a", {
                    onClick: ($event: any) => (_ctx.redirectTo(inboxUsername.username)),
                    class: 
                inboxUsername.username === _ctx.activeDiscussion
                  ? 'active_conversation'
                  : ''
              
                  }, [
                    _createVNode("div", _hoisted_2, [
                      _createVNode("figure", _hoisted_3, [
                        _createVNode("img", {
                          class: "is-rounded",
                          src: _ctx.getLink(inboxUsername.hashedUsername)
                        }, null, 8, ["src"]),
                        _hoisted_4
                      ]),
                      _createVNode("div", _hoisted_5, [
                        _createVNode("h5", null, [
                          _createTextVNode(_toDisplayString(inboxUsername.username) + " ", 1),
                          (inboxUsername.username === _ctx.activeDiscussion)
                            ? (_openBlock(), _createBlock("span", _hoisted_6, [
                                _hoisted_7
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (
                      inboxUsername.nbOfUnreadMessages > 0 &&
                        inboxUsername.nbOfUnreadMessages < 10
                    )
                          ? (_openBlock(), _createBlock("span", _hoisted_8, " +" + _toDisplayString(inboxUsername.nbOfUnreadMessages), 1))
                          : (inboxUsername.nbOfUnreadMessages > 9)
                            ? (_openBlock(), _createBlock("span", _hoisted_9, " +9 "))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ], 10, ["onClick"])
                ]))
              }), 128))
            ])
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.activeDiscussion)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: "inbox_messages",
            style: {
          width: _ctx.windowWidth < 768 ? '100%' : '80%'
        }
          }, [
            _createVNode("h4", _hoisted_10, [
              _createVNode(_component_router_link, { to: "/inbox" }, {
                default: _withId(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.activeDiscussion), 1),
              _createVNode("div", {
                class: `dropdown is-right dropdown_right ${_ctx.isActiveDropdown}`
              }, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("a", {
                    class: "is-active is-white",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropDown && _ctx.toggleDropDown(...args)), ["stop"])),
                    "data-testid": "conversation-setting-button"
                  }, [
                    _hoisted_13
                  ])
                ]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode("div", {
                      class: "dropdown-item is-clickable",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteConversation && _ctx.deleteConversation(...args))),
                      "data-testid": "conversation-delete-button"
                    }, " Delete conversation "),
                    _hoisted_17
                  ])
                ])
              ], 2)
            ]),
            _createVNode("div", {
              class: "padding-0-15",
              id: "messages_container",
              style: { height: _ctx.windowHeight - 120 + 'px' }
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeDiscussionMessages, (m, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: "is-relative margin-10-0"
                }, [
                  _createVNode("div", null, [
                    (
                  (_ctx.activeDiscussionMessages[index - 1] &&
                    _ctx.sameDayMessage(index)) ||
                    index === 0
                )
                      ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.moment(m.created_at).format("ll")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("figure", _hoisted_20, [
                      _createVNode("img", {
                        class: "is-rounded",
                        src: _ctx.getProfilePicture(m.from)
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("span", _hoisted_22, [
                      _createVNode("b", _hoisted_23, _toDisplayString(m.from), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.moment(m.created_at).format("HH:mm")), 1)
                    ]),
                    _createVNode("p", _hoisted_24, _toDisplayString(m.text), 1)
                  ])
                ]))
              }), 128))
            ], 4),
            (_ctx.activeDiscussion)
              ? (_openBlock(), _createBlock("div", _hoisted_25, [
                  _createVNode("div", _hoisted_26, [
                    _withDirectives(_createVNode("input", {
                      class: "input is-white is-background-black",
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.messageToSend = $event)),
                      onKeypress: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"])),
                      "data-testid": "inbox-input"
                    }, null, 544), [
                      [_vModelText, _ctx.messageToSend]
                    ])
                  ]),
                  _createVNode("p", _hoisted_27, [
                    _createVNode("a", {
                      class: "button is-background-black",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)))
                    }, [
                      _hoisted_28
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 4))
        : (!_ctx.activeDiscussion && _ctx.messages.length === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33
            ]))
          : _createCommentVNode("", true)
    ], 4)
  ], 4))
})